export default {
	TABLE_TITLE: 'Waiting Time grids',
	WAITING_TIME_GRID_ADDED: 'Waiting time grid added',
	WAITING_TIME_GRID_EDITED: 'Waiting time grid edited',
	WAITING_TIME_GRID_DELETED: 'Waiting time grid deleted',
	WORKPLACE_WAITING_TIME_GRIDS: 'Workplace waiting time grids',
	WAITING_TIME_GRID_ENTRIES: 'Waiting time grid entries'
};
